import { ROUTER_PATHS } from '@constants/router';
import Company from 'images/home/company.svg';
import Establishment from 'images/home/establishment.svg';
import People from 'images/home/people.svg';
import ToGo from 'images/to-go.svg';

export const HOME_SPLASH_CONFIG = {
  titleKey: 'home.splash.title',
  subtitleKey: 'home.splash.subtitle',
  primaryLink: ROUTER_PATHS.HOME,
  primaryLinkKey: 'home.splash.primary-link',
  secondaryLink: ROUTER_PATHS.HOME,
  secondaryLinkKey: 'home.splash.secondary-link',
};

export const SHOWCASE_CONFIG = {
  titleKey: 'home.showcase-items.title',
  items: [
    {
      imgSrc: People,
      titleKey: 'home.showcase-items.1.title',
      subtitleKey: 'home.showcase-items.1.subtitle',
    },
    {
      imgSrc: Company,
      titleKey: 'home.showcase-items.2.title',
      subtitleKey: 'home.showcase-items.2.subtitle',
    },
    {
      imgSrc: Establishment,
      titleKey: 'home.showcase-items.3.title',
      subtitleKey: 'home.showcase-items.3.subtitle',
    },
  ],
};

export const BLOCK_CARDS_CONFIG = [
  {
    titleKey: 'home.block-cards.1.title',
    linkKey: 'home.block-cards.1.link',
    imgSrc: ToGo,
  },
];

export const FOOTER_CALLOUT_CONFIG = {
  titleKey: 'home.footer-callout.title',
  linkKey: 'home.footer-callout.link',
  link: ROUTER_PATHS.GUIDES,
};
